import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarketCompaniesThatYouCompeteComponent } from './market-companies-that-you-compete.component';
import { MdbGlobalModule } from 'src/app/shared/mdb-global.module';
import { DxButtonModule, DxDataGridModule, DxNumberBoxModule, DxPopupModule, DxScrollViewModule, DxTextBoxModule } from 'devextreme-angular';



@NgModule({
  declarations: [
    MarketCompaniesThatYouCompeteComponent
  ],
  imports: [
    CommonModule,
    MdbGlobalModule,
    DxDataGridModule,
    DxButtonModule,
    DxPopupModule,
    DxScrollViewModule,
    DxTextBoxModule,
    DxNumberBoxModule
  ],
  exports: [
    MarketCompaniesThatYouCompeteComponent
  ]
})
export class MarketCompaniesThatYouCompeteModule { }
